import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'

export function useUpdateAgreement(id_client?: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const body = {
        id_client
      }

      if (!body.id_client) {
        throw new Error('Campos obrigatórios ausentes')
      }

      const response = await api.post(`/agreement/update`, body)

      if (!response.data) {
        throw new Error('Erro ao atualizar contrato')
      }

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
    }
  })
}
